import { Injectable } from '@angular/core';
import { UfFilterState } from '../states/UfFilter.state';
import { FilterableUfService } from '../services/filterableUf.service';
import { PlanoFacade } from './plano.facade';
import { OperadoraFacade } from './operadora.facade';

@Injectable({ providedIn: 'root' })
export class UfFilterFacade {
  constructor(
    private filterableUfService: FilterableUfService,
    private planoFacade: PlanoFacade,
    private operadoraFacade: OperadoraFacade,
    private state: UfFilterState,
  ) { }

  fetchUfs() {
    if(!this.state.hasUfs()) {
      this.filterableUfService.getUfs().subscribe(ufs => {
        this.state.setUfs(ufs);
      });
    }
  }

  getSelectedUf() {
    return this.state.getSelectedUf();
  }

  observeSelectedUf() {
    return this.state.observerSelectedUf();
  }

  getUfs() {
    return this.state.getUfs();
  }

  filterHealthPlans(ufDescription: string) {
    this.planoFacade.filterByUf(ufDescription);
    this.state.selectByName(ufDescription);
  }

  clearHealthPlansFilter() {
    this.planoFacade.clearFilter();
    this.state.setSelectedUf(null);
  }

  filterProductMaterials(ufDescription: string) {
    this.operadoraFacade.filterByUf(ufDescription);
    this.state.selectByName(ufDescription);
  }

  clearProductMaterialsFilter() {
    this.operadoraFacade.clearFilter();
    this.state.setSelectedUf(null);
  }
}